export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/app.worker.6cde314e.worker.js");
}
